import * as React from "react";
const SvgChevronUpFilled = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={10} fill="none" viewBox="0 0 12 10" {...props}><path fill="#000" d="m6.249.502 5.411 9.374H.837z" /></svg>;
export { SvgChevronUpFilled as ReactComponent };